import { configureStore } from "@reduxjs/toolkit";
import costHistoryReducer from "./costHistorySlice";
import MyProfileSubscriptionReducer from "./MyProfileSubscriptionSlice";
import CheckChargebeeSubscriptionReducer from "./CheckChargebeeSubscriptionSlice";
import ProfileUpdateReducer from "./ProfileUpdateSlice";
import ChatFlagReducer from "./ChatFlagSlice";
import deleteFlag from "./DeleteModelFlagSlice";
import OTPCounterReducer from "./OTPCounterSlice";
import ResendCodeReducer from "./ResendCodeSlice";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const reducer = combineReducers({
  ResendCode: ResendCodeReducer,
  MyProfileSubscription: MyProfileSubscriptionReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: {
    ChatFlag: ChatFlagReducer,
    ProfileUpdate: ProfileUpdateReducer,
    costHistory: costHistoryReducer,
    DeleteFlag: deleteFlag,
    OTPCounter: OTPCounterReducer,
    CheckChargebee: CheckChargebeeSubscriptionReducer,
    PersistedData: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export default store;
